<template>
  <MessageBoxBase
    class="com_message-box--success"
  >
    <slot />
  </MessageBoxBase>
</template>

<script>
import MessageBoxBase from '@/components/MessageBoxBase.vue'

export default {
  name: 'MessageBoxSuccess',

  components: {
    MessageBoxBase,
  },
}
</script>
